module.exports = __webpack_public_path__ + "img/play-button-groot.8675711eb495f5a2f7e17640a9a6c323.svg";